var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification",class:_vm.notification.status,on:{"click":function($event){return _vm.remove_notification()}}},[_vm._v(" "+_vm._s(_vm.notification.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }